const getObjectRecord = (value: unknown): Record<string, unknown> | null => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;

  return value as Record<string, unknown>;
};

export const getRetryAfterSeconds = (error: unknown): number | null => {
  const errorRecord = getObjectRecord(error);
  const responseRecord = getObjectRecord(errorRecord?.response);

  if (responseRecord?.status !== 429) return null;

  const dataRecord = getObjectRecord(responseRecord.data);
  const detailsRecord = getObjectRecord(dataRecord?.details);
  const retryAfterSeconds = detailsRecord?.retry_after_seconds;

  if (
    typeof retryAfterSeconds !== 'number'
    || !Number.isInteger(retryAfterSeconds)
    || retryAfterSeconds <= 0
  ) {
    return null;
  }

  return retryAfterSeconds;
};